import React from 'react';
import "../../../assets/css/patient/ConsultAI.css";

const FeatureCard = ({ icon, title, description }) => (
  <div className="consultai-feature-card">
    <div className="consultai-card-shine"></div>
    <div className="consultai-feature-icon">{icon}</div>
    <h3>{title}</h3>
    <p>{description}</p>
  </div>
);

const ConsultAISection = () => {
  return (
    <section className="consultai-wrapper">
      <div className="consultai-particles">
        {Array.from({ length: 8 }).map((_, i) => (
          <div key={i} className="consultai-particle"></div>
        ))}
      </div>

      <div className="consultai-content">
        <div className="consultai-badge">
          <span className="consultai-pulse-dot"></span>
          AI-Powered Technology
        </div>

        <h2 className="consultai-title">
          Intelligent Speech Therapy <br />
          <span className="consultai-gradient-text">Powered by Advanced AI</span>
        </h2>

        <p className="consultai-description">
          Our cutting-edge artificial intelligence analyzes speech patterns in real-time, 
          providing personalized feedback and adaptive exercises tailored to each individual's 
          unique needs and progress.
        </p>

        <div className="consultai-features-grid">
          <FeatureCard icon="🎯" title="Smart Analysis" description="Real-time speech pattern recognition and detailed pronunciation analysis" />
          <FeatureCard icon="📊" title="Progress Tracking" description="AI-driven insights and comprehensive performance metrics" />
          <FeatureCard icon="🎓" title="Adaptive Learning" description="Personalized exercises that evolve with your improvement" />
          <FeatureCard icon="⚡" title="Instant Feedback" description="Immediate corrections and encouraging guidance in real-time" />
        </div>

        {/* Buttons removed */}
      </div>

      <div className="consultai-shape consultai-shape-1"></div>
      <div className="consultai-shape consultai-shape-2"></div>
      <div className="consultai-shape consultai-shape-3"></div>
    </section>
  );
};

export default ConsultAISection;